export interface CatalogPromotion {
    id: ID;
    products?: ID[];
    type: CatalogPromotionType;
    name: string;
    caption?: string;
    value?: number;
}

export enum CatalogPromotionType {
    DISCOUNT_PERCENT = "percent_discount",
    ABSOLUTE_DISCOUNT_PER_PURCHASE = "absolute_discount_per_purchase",
}
